import { hasUser } from 'contexts/auth/helpers';
import useAuth from 'contexts/auth/useAuth';

import { getUsernameOrAddress } from 'utils/helpers';
import { buildClaimTweet } from 'utils/twitter-templates';

import { useSocialVerificationByService } from './queries/hasura/social-verification/use-social-verification';

interface BuyTweetTextVariables {
  name: string | null;
  creatorName: string | null;
  creatorUsername: string | null;
  publicKey: string;
}

export default function useBuyTweetText(variables: BuyTweetTextVariables) {
  const { name, creatorName, publicKey, creatorUsername } = variables;

  const auth = useAuth();
  const currentUser = hasUser(auth) ? auth.user : undefined;
  const artworkCreatorName = creatorName ?? creatorUsername;

  const { data: socialVerificationsData } = useSocialVerificationByService({
    publicKey,
    service: 'TWITTER',
  });

  const twitterShareText = buildClaimTweet({
    // @ts-expect-error null-checks
    artworkName: name,
    // @ts-expect-error null-checks
    creatorName: artworkCreatorName,
    // @ts-expect-error null-checks
    usernameOrAddress: getUsernameOrAddress(currentUser),
    // @ts-expect-error null-checks
    twitterUsername: socialVerificationsData?.username,
  });

  return twitterShareText;
}
